/* eslint-disable max-len */
const UserIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="20"
        cy="12.0001"
        rx="6.4"
        ry="6.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4 34.4001V31.2001C10.4 27.6654 13.2654 24.8 16.8 24.8H23.2C26.7346 24.8 29.6 27.6654 29.6 31.2001V34.4001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UserIcon;
